import { render } from "./FormRegisterSection1.vue?vue&type=template&id=2a91198c&scoped=true"
import script from "./FormRegisterSection1.vue?vue&type=script&lang=js"
export * from "./FormRegisterSection1.vue?vue&type=script&lang=js"

import "./FormRegisterSection1.vue?vue&type=style&index=0&id=2a91198c&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a91198c"]])

export default __exports__